<script setup lang="ts">
import { AtlasCard } from '@/components/ui'
import { useI18n } from '@/composables/useI18n'
import type { Concept } from '@/models/concept-set.types'

const { t } = useI18n()

defineProps<{ concept: Concept }>()
</script>

<template>
  <AtlasCard
    padding="none"
    data-testid="concept-attributes-card"
  >
    <header class="card-title">
      {{ t('components.conceptDetail.conceptDetailsTitle').value }}
    </header>
    <div class="card-body">
      <dl class="kv">
        <dt>{{ t('components.conceptDetail.conceptId').value }}</dt><dd class="mono">
          {{ concept.conceptId }}
        </dd>
        <dt>{{ t('cs.manager.concept.tabs.details.conceptCode').value }}</dt><dd class="mono">
          {{ concept.conceptCode }}
        </dd>
        <dt>{{ t('columns.domain').value }}</dt><dd>{{ concept.domainId }}</dd>
        <dt>{{ t('columns.vocabulary').value }}</dt><dd>{{ concept.vocabularyId }}</dd>
        <dt>{{ t('components.conceptDetail.conceptClass').value }}</dt><dd>{{ concept.conceptClassId }}</dd>
        <dt>{{ t('cs.manager.concept.tabs.details.standardConcept').value }}</dt><dd>{{ concept.standardConcept ?? '—' }}</dd>
        <dt>{{ t('cs.manager.concept.tabs.details.invalidReason').value }}</dt><dd>{{ concept.invalidReason ?? '—' }}</dd>
      </dl>
    </div>
  </AtlasCard>
</template>

<style scoped>
.card-title {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--atlas-color-on-surface-variant);
  font-weight: 600;
  padding: 12px 16px;
  border-bottom: 1px solid var(--atlas-color-outline);
}
.card-body {
  padding: 16px;
}
.kv {
  display: grid;
  grid-template-columns: 140px 1fr 140px 1fr;
  row-gap: 6px;
  column-gap: 16px;
  font-size: 13px;
  margin: 0;
}
.kv dt {
  color: var(--atlas-color-on-surface-variant);
}
.kv dd {
  margin: 0;
  font-weight: 500;
}
.mono {
  font-family: 'JetBrains Mono', 'SF Mono', Consolas, monospace;
}
@media (max-width: 768px) {
  .kv {
    grid-template-columns: 140px 1fr;
  }
}
</style>
